<template>
  <div id="login-app">
    <div class="login-container" :class="{ 'no-bg': noBg, 'no-border': noBorder, en: !appStore.isCN, 'is-in-iframe': isInIframe, 'is-in-webview-v1': isInWebviewV1 }">
      <LoginBg v-if="!noBg"></LoginBg>
      <RouterView :class="{ 'is-join-company': isJoinCompany }"></RouterView>
    </div>
    <p class="tips" v-if="showTips" v-html="$t('Register & log in UPDF account You can convert <span>2 files per day</span> for FREE')"></p>
  </div>
</template>

<script setup>
import { appStore } from '@/stores';
import { RouterView, useRoute } from 'vue-router';
import { computed, onMounted, ref, watch } from 'vue';
import { setLoginResultTmp } from '@/services/login';
import { useWindowSize } from '@vueuse/core';
import { isInWebview } from '@/libs/utils';
import LoginBg from './components/login-bg.vue';
import { getUrlQuery } from '@/libs/tools';
const $route = useRoute()

const { width: windowWidth } = useWindowSize({ listenOrientation: false })

const isMobile = computed(() => {
  return windowWidth.value < 840
})

// 是否是在旧版本webview中(旧版本尺寸需要兼容)
const isInWebviewV1 = isInWebview() && !getUrlQuery('version')

// 官网等iframe方式引入时使用无背景无边框方式
const isInIframe = computed(() => {
  return appStore.isIframe
})

// 不需要背景和边框的路由名称
const noBorderAndBgRouteNames = ['loginCallback', 'loginJoinConfirm', 'loginJoinSuccess']

// 手机版、iframe中、登录成功页无背景图
const noBg = computed(() => {
  return  (isMobile.value && !isInWebview()) || isInIframe.value || (noBorderAndBgRouteNames.includes($route.name))
})

// 手机版、iframe中、登录成功页、webview中无边框
const noBorder = computed(() => {
  return  isMobile.value || (noBorderAndBgRouteNames.includes($route.name) || appStore.isInWebview || isInIframe.value)
})

// 是否显示权益提示
const showTips = computed(() => {
  return isInIframe.value && !['updfAI'].includes($route.query?.loginFrom)
})

const isJoinCompany = computed(() => {
  return $route.query?.action === 'joinCompany'
})

watch(() => $route.name, () => {
  if (['loginWechat', 'loginAccountInput'].includes($route.name)) {
    // 登录前或登录成功后，清除之前的登录结果缓存
    setLoginResultTmp(null)
  }
})

onMounted(() => {
  
})
</script>

<style lang="scss">
@use 'base.scss';
.tips {
  font-size: 12px;
  line-height: 16px;
  color: var(--BG-10, #222222);
  padding: 8px 14px;
  border-radius: 75px;
  background: #00000014;
  text-align: center;
  max-width: 90%;
  box-sizing: border-box;
  margin-top: 30px;
  span {
    color: var(--Color-1, #7479FF);
  }
}
</style>